import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { LoadingButton } from '../../ui/Button.tsx';

export function MapFallback({ resetErrorBoundary }: FallbackProps) {
  const { t } = useTranslation();
  return (
    <div className="map-container d-flex flex-column align-items-center justify-content-center">
      <p className={'text-basic mb-2'}>{t('map.error')}</p>
      <LoadingButton
        type={'submit-button'}
        text={t('map.fallback-button')}
        onClick={resetErrorBoundary}
        loading={false}
        disabled={false}
        imagePath={null}
      />
    </div>
  );
}
